// fetches file from server via /api/asset and stores temp url
import { useState, useCallback } from 'react';
import { getServerFile } from '%/s3functions';
import conso from '%/conso';
import { getDefaultImage } from '../utils/functions';

export const domain = 'https://dss-local-storage-i.s3.amazonaws.com/'

const useFetchFile = () => {

  const [fileLoad, setFileLoad] = useState(false);
  const [fileData, setFileData] = useState('');
  const [fileError, setFileError] = useState('');

  const makeFetchRequest = useCallback((path) => {
    if (path === false) {
      setFileData(false);
    }
    if (!path) {
      setFileData(getDefaultImage());
      return null
    };
    if((/^http/).test(path)) {
      return setFileData(path);
    }
    
    setFileData(domain + (path[0] === '/' ? path.slice(1): path) );
    // setFileLoad(true);
    
    // try {
    //   const res = await getServerFile(path);
    //   if (res) {
    //     // res needs to be a url generated from file object
    //     setTimeout(() => {
    //       setFileData(res);
    //       setFileLoad(false);
    //     }, 200)
    //     return res;
    //   }
    //   setFileLoad(false);
    //   if (!res) {
    //     throw new Error();
    //   }
    // } catch (er) {
    //   conso.trace(er);
    //   throw new Error();
    // }
  }, [])

  return {
    fileLoad,
    fileData,
    makeFetchRequest,
    fileError,
    setFileError,
    setFileData
  }
}
export default useFetchFile;